import { authClient, API } from "../index";

// Count all leatVentas
export const countLeatVentas = () => {
  return authClient().get(`${API}/leatVenta/count`);
};

// Get all leatVentas
export const getLeatVentas = () => {
  return authClient().get(`${API}/leatVenta`);
};

// Get leatVenta by id
export const getLeatVentaById = (id) => {
  return authClient().get(`${API}/leatVenta/${id}`);
};

// Update leatVenta
export const updateLeatVenta = (id, leatVenta) => {
  return authClient().put(`${API}/leatVenta/${id}`, leatVenta);
};

// Update all leatVentas with the given email (estadoLead, notasLead, fechaContacto)
export const updateLeatVentasByEmail = (email, payload) => {
  return authClient().patch(`${API}/leatVenta/update-by-email`, { email, ...payload });
};

// CreatVentae leatVenta
export const postLeatVenta = (leatVenta) => {
  return authClient().post(`${API}/leatVenta`, leatVenta);
};

// Delete leatVenta
export const deleteLeatVenta = (id) => {
  return authClient().delete(`${API}/leatVenta/${id}`);
};

// Count unread leatVentas
export const countUnreadLeatVentas = () => {
  return authClient().get(`${API}/leatVenta/count-unread`);
};

export const markLeatVentasAsRead = () => {
  return authClient().patch(`${API}/leatVenta/mark-all-read`);
};